const isDebugEnabled = () => {
  if (typeof window !== 'undefined' && window.__LOG_LEVEL === 'debug') {
    return true;
  }
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEBUG_LOGS === 'true') {
    return true;
  }
  return false;
};

const withConsole = (fn, ...args) => {
  if (!isDebugEnabled()) return;
  try {
    fn(...args);
  } catch {
    // Ignore console errors
  }
};

const logger = {
  log: (...args) => withConsole(console.log, ...args),
  warn: (...args) => withConsole(console.warn, ...args),
  time: (...args) => withConsole(console.time, ...args),
  timeEnd: (...args) => withConsole(console.timeEnd, ...args)
};

export default logger;
